var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBotYear01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 116.25 112.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#39a7df;}.cls-2{fill:#fff;}.cls-3{fill:#9b9a9a;}.cls-4{fill:#9c9b9b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 58.13,
    cy: 41.12,
    r: 35.2,
    transform: "translate(-1.66 2.45) rotate(-2.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.64,36.37a9.37,9.37,0,0,0-9.23-8.94H59.06V21.2a1.95,1.95,0,1,0-1.87,0v6.23H42.84a9.36,9.36,0,0,0-9.22,8.94,4.93,4.93,0,0,0-3.85,4.72v6a4.92,4.92,0,0,0,3.91,4.72A9.37,9.37,0,0,0,42.84,60H73.41a9.37,9.37,0,0,0,9.16-8.13,4.91,4.91,0,0,0,3.91-4.72v-6A4.93,4.93,0,0,0,82.64,36.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M58.13,0A41.12,41.12,0,1,0,99.25,41.12,41.12,41.12,0,0,0,58.13,0Zm0,79.88A38.76,38.76,0,1,1,96.89,41.12,38.76,38.76,0,0,1,58.13,79.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.43,53.88l-.58,0a9.4,9.4,0,1,1,0-18.8,10.65,10.65,0,0,1,7.54,3,19.88,19.88,0,0,1,2.69,3.23A18.91,18.91,0,0,1,60.82,38a10.62,10.62,0,0,1,7.54-3,9.4,9.4,0,1,1,0,18.8,9.47,9.47,0,0,1-7.21-2.6,19.18,19.18,0,0,1-3.06-3.79,19.54,19.54,0,0,1-3.06,3.79,9.46,9.46,0,0,1-6.64,2.62Zm7.75-9.54a19.12,19.12,0,0,0-3-3.89,7.33,7.33,0,0,0-5.27-2.07,6.09,6.09,0,1,0,0,12.16H48a6.25,6.25,0,0,0,4.85-1.73,21.8,21.8,0,0,0,3.35-4.48Zm12.18-6a7.35,7.35,0,0,0-5.28,2.07,18.74,18.74,0,0,0-3,3.89,21.1,21.1,0,0,0,3.35,4.48,6.23,6.23,0,0,0,4.84,1.73h.09a6.09,6.09,0,1,0,0-12.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M50.81,43.53H49.32V42.05a.31.31,0,0,0-.31-.32H47.78a.32.32,0,0,0-.32.32v1.48H46a.32.32,0,0,0-.32.32v1.22a.32.32,0,0,0,.32.32h1.48v1.49a.32.32,0,0,0,.32.32H49a.32.32,0,0,0,.31-.32V45.39h1.49a.32.32,0,0,0,.32-.32V43.85A.32.32,0,0,0,50.81,43.53Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 65.36,
    y: 43.53,
    width: 5.47,
    height: 1.86,
    rx: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 65.36,
    y: 43.53,
    width: 5.47,
    height: 1.86,
    rx: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M50.78,43.53H49.32V42.07a.34.34,0,0,0-.34-.34H47.81a.35.35,0,0,0-.35.34v1.46H46a.35.35,0,0,0-.34.35v1.17a.34.34,0,0,0,.34.34h1.46v1.46a.35.35,0,0,0,.35.35H49a.35.35,0,0,0,.34-.35V45.39h1.46a.35.35,0,0,0,.35-.34V43.88A.35.35,0,0,0,50.78,43.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.13,15.92a3.54,3.54,0,0,0-2.31.84.28.28,0,0,0,0,.4.25.25,0,0,0,.35,0,3,3,0,0,1,4,0,.27.27,0,0,0,.34-.42A3.54,3.54,0,0,0,58.13,15.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M62.65,14.17a7,7,0,0,0-9,0,.53.53,0,0,0,0,.77.52.52,0,0,0,.71,0A5.95,5.95,0,0,1,62,15a.52.52,0,0,0,.71,0h0A.53.53,0,0,0,62.65,14.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.13,14.38a5.11,5.11,0,0,0-3.31,1.21.39.39,0,0,0,0,.57.37.37,0,0,0,.51,0,4.34,4.34,0,0,1,5.64,0,.37.37,0,0,0,.51,0,.39.39,0,0,0,0-.57A5.15,5.15,0,0,0,58.13,14.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,88H5.68a4.09,4.09,0,0,1,3,1,2.45,2.45,0,0,1,.71,1.79v0a2.55,2.55,0,0,1-1.71,2.47A2.7,2.7,0,0,1,9.91,96v0c0,1.9-1.55,3.06-4.19,3.06H0ZM4.92,92.4c.94,0,1.46-.31,1.46-1v0c0-.6-.47-1-1.39-1H3v2Zm.45,4.2c.93,0,1.47-.37,1.47-1v0c0-.6-.47-1-1.5-1H3v2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.94,93.56v0a5.81,5.81,0,0,1,6-5.77,5.75,5.75,0,0,1,5.95,5.73v0a5.81,5.81,0,0,1-6,5.76A5.75,5.75,0,0,1,10.94,93.56Zm8.8,0v0a2.88,2.88,0,0,0-2.85-3,2.83,2.83,0,0,0-2.8,3v0a2.88,2.88,0,0,0,2.84,3A2.82,2.82,0,0,0,19.74,93.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.71,90.68H23.39V88h9.72v2.7H29.78v8.39H26.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33.6,93.56v0a6,6,0,0,1,11.94,0v0a5.81,5.81,0,0,1-6,5.76A5.75,5.75,0,0,1,33.6,93.56Zm8.8,0v0a2.88,2.88,0,0,0-2.85-3,2.83,2.83,0,0,0-2.8,3v0a2.88,2.88,0,0,0,2.83,3A2.82,2.82,0,0,0,42.4,93.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47.14,88h3.07v8.4h5.37v2.69H47.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M58,94.92,53.82,88h3.5l2.28,4,2.29-4h3.44l-4.21,6.89v4.2H58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M66.28,88h3.25l2.64,4.3L74.82,88h3.24V99.07H75V92.7L72.17,97h-.06l-2.82-4.31v6.34h-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M80,88h4.75c2.81,0,4.61,1.45,4.61,3.9v0c0,2.61-2,4-4.76,4H83.1v3.17H80Zm4.53,5.51c1.1,0,1.76-.57,1.76-1.44v0c0-1-.66-1.45-1.77-1.45H83.1v2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M90.74,88h3.09V99.07H90.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M95.48,93.56v0a5.7,5.7,0,0,1,5.84-5.77,5.42,5.42,0,0,1,4.7,2.31l-2.31,1.79a3,3,0,0,0-2.42-1.29,2.73,2.73,0,0,0-2.64,2.92v0a2.74,2.74,0,0,0,2.64,3,3,3,0,0,0,2.5-1.35l2.31,1.65a5.83,5.83,0,0,1-10.62-3.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M106.58,97.42l1.71-2a5.7,5.7,0,0,0,3.59,1.33c.83,0,1.27-.29,1.27-.76v0c0-.46-.37-.72-1.87-1.06-2.36-.54-4.18-1.21-4.18-3.49v0c0-2.06,1.63-3.55,4.29-3.55A6.94,6.94,0,0,1,116,89.27l-1.53,2.17a5.55,5.55,0,0,0-3.11-1.1c-.74,0-1.11.32-1.11.72v0c0,.5.38.73,1.92,1.07,2.55.56,4.13,1.38,4.13,3.46v0c0,2.26-1.79,3.61-4.48,3.61A7.73,7.73,0,0,1,106.58,97.42Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 21.96,
    y: 107.73,
    width: 17.97,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 76.33,
    y: 107.73,
    width: 17.97,
    height: 0.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.36,110.53l3.07-2.35c.76-.6,1-1,1-1.48a.82.82,0,0,0-.91-.83c-.55,0-1,.32-1.63,1.06l-1.54-1.28a3.8,3.8,0,0,1,3.35-1.76c1.79,0,3,1.07,3,2.61v0c0,1.31-.68,2-1.9,2.87l-1.41,1h3.39v1.85H43.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.77,108.16v0c0-2.32,1.48-4.26,3.81-4.26s3.79,1.92,3.79,4.24v0c0,2.33-1.47,4.27-3.81,4.27S50.77,110.48,50.77,108.16Zm5.31,0v0c0-1.3-.62-2.25-1.52-2.25s-1.5.92-1.5,2.23v0c0,1.32.61,2.26,1.52,2.26S56.08,109.46,56.08,108.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.12,110.53l3.07-2.35c.76-.6,1.06-1,1.06-1.48a.82.82,0,0,0-.92-.83c-.55,0-1,.32-1.63,1.06l-1.53-1.28a3.79,3.79,0,0,1,3.34-1.76c1.79,0,3,1.07,3,2.61v0c0,1.31-.68,2-1.9,2.87l-1.4,1h3.39v1.85h-6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.26,111l1.43-1.43a2.69,2.69,0,0,0,2,.94c.65,0,1.06-.33,1.06-.84v0c0-.53-.48-.84-1.34-.84h-1l-.33-1.19,1.89-1.7H66.82V104h5.94v1.63l-2,1.68a2.31,2.31,0,0,1,2.12,2.31v0c0,1.67-1.33,2.73-3.16,2.73A4.47,4.47,0,0,1,66.26,111Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotYear01);
export default __webpack_public_path__ + "static/media/bot_year-01.9195c7344fc781ea2ebefff356758a2b.svg";
export { ForwardRef as ReactComponent };